import * as React from 'react';
import { clsx } from 'clsx';
import { getStyles } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент для рендера полноэкранного модального окна
 *
 * @export
 * @class ModalFullscreen
 * @extends {React.Component<IModalFullscreenViewProps>}
 */
export function ModalFullscreenView(_ref) {
  var children = _ref.children,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'white' : _ref$theme,
    _ref$print = _ref.print,
    print = _ref$print === void 0 ? true : _ref$print,
    zIndex = _ref.zIndex;
  var styles = getStyles(theme);
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['fullscreen'], !print && styles['no-print']),
    style: {
      zIndex: zIndex
    },
    "aria-modal": "true",
    role: "dialog",
    children: children
  });
}